import type { TypeFormFieldElement } from '../../../types/form';

// ----------------------------------------------------------------------------

function getRequiredMessage(field: TypeFormFieldElement, name: string): string {
    if (!field.required || !field.validity.valueMissing) {
        return '';
    }

    const requiredMessage = field.getAttribute('required')?.trim();

    if (requiredMessage != null && requiredMessage.length > 0) {
        return requiredMessage;
    }

    return `The field '${name}' is required.`;
}

// ----------------------------------------------------------------------------

export default getRequiredMessage;
